import 'components/select';
import QueryString from 'utils/query_string';
import './index.scss';

const PER_PAGE_PERMISSIONS = ['account', 'confirmed_account', 'subscription'];

class QuestionPerPageInput {
  constructor() {
    this.$component = $('.js-question-per-page');
    this.bindEvents();
  }

  bindEvents() {
    this.$component.qselect('on', 'change', this.change.bind(this));
  }

  checkPerPageChangePermissions(value) {
    const defaultValuePerPage = '5';

    if (value === defaultValuePerPage) {
      return true;
    }

    const { proceed, reason } = window.permissions.hasPermissions(PER_PAGE_PERMISSIONS);

    if (proceed) {
      return true;
    }
    this.$component.qselect('close');
    const myEvent = new CustomEvent(reason, {
      detail: {
        type: 'per_page'
      }
    });
    window.permissions.feedbacks[reason](myEvent);

    if (!window.currentUser) {
      return;
    }

    UserTracker.emit('event', {
      eventName: 'account restriction reached',
      data: {
        'resource restricted': 'per page'
      }
    });

    return false;
  }

  async change(value) {
    if (!this.checkPerPageChangePermissions(value)) {
      this.$component.qselect('setValue', 5);
      return;
    }

    const query = QueryString.getQueryStringData();
    query.per_page = value;

    await Thor.UserPreference.update(
      {},
      {
        data: {
          user_preferences: {
            questions_per_page: value
          }
        }
      }
    );

    Turbolinks.visit(`${location.pathname}?${QueryString.parseQueryStringData(query)}`);
  }
}

(function () {
  'use strict';
  new QuestionPerPageInput();
})();
